import script from "./LightRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./LightRegister.vue?vue&type=script&setup=true&lang=js"

import "./LightRegister.vue?vue&type=style&index=0&id=e755f4aa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e755f4aa"]])

export default __exports__